// test2053
(2053 && 0);
